import axios from 'axios'

export default class captcha {

    public async obtenerVerificacionCaptcha(parametros:any): Promise<[] | undefined> {

        try {
            const api = process.env.VUE_APP_RECAPTCHA_API + 'ValidateRecaptcha';                      
            const config = {                
                headers: {
                    Content: 'application/json',
                    responseType: "json"
                }
            };

            return axios.post(api, parametros, config);

        } catch (error) {
            throw new Error('API (obtenerVerificacionCaptcha). ' + error)
        }
    }

    public async GetKeysRecaptcha(): Promise<[] | undefined> {
        try {

            const api = process.env.VUE_APP_RECAPTCHA_API +  'GetKeysRecaptcha'; 
            const config = {             
                    headers: {
                        responseType: "json" 
                    }
                };     

            return axios.get(api, config);

        } catch (error) {
            throw new Error('API (GetKeysRecaptcha). ' + error) 
        }
    }    

}